import { render } from "./cellSpent.vue?vue&type=template&id=0868479e&scoped=true"
import script from "./cellSpent.vue?vue&type=script&lang=js"
export * from "./cellSpent.vue?vue&type=script&lang=js"
script.render = render
script.__scopeId = "data-v-0868479e"

export default script